export default "__VITE_ASSET__BYr5axua__"